import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { AuthShell, Field } from "./Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated — sign in with your new password.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Invalid link" subtitle="This reset link is missing its token">
        <p className="text-sm text-zinc-400 mb-4" data-testid="reset-no-token">
          The link you followed is incomplete. Request a fresh one and try again.
        </p>
        <Link to="/forgot-password" data-testid="reset-request-new" className="block text-center w-full bg-blue-600 hover:bg-blue-500 py-2.5 rounded-md font-semibold transition-colors">
          Request a new link
        </Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a new password" subtitle="Make it at least 8 characters">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        {error && <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2" data-testid="reset-error">{error}</p>}
        <Field label="New password" type="password" value={password} onChange={setPassword} testid="reset-password" />
        <Field label="Confirm password" type="password" value={confirm} onChange={setConfirm} testid="reset-confirm" />
        <button disabled={loading} data-testid="reset-submit" className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 py-2.5 rounded-md font-semibold transition-colors">
          {loading ? "Updating…" : "Update password"}
        </button>
      </form>
      <p className="text-sm text-zinc-500 mt-6 text-center">
        Back to <Link to="/login" className="text-blue-400 hover:text-blue-300">Sign in</Link>
      </p>
    </AuthShell>
  );
}
